var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNil } from '../_internal/data';
import { stringifyColor, applyOpacityToColor } from '../color';
import { palette } from '../palette';
import { DEFAULT_THEME } from './theme.data';
export var getCurrentBackground = function (props, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, useRootTheme = _c.useRootTheme;
    var theme = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.uiCore;
    if (!theme) {
        return palette.neutralWhiteWithOpacityFading[1000];
    }
    var themeValue = useRootTheme ? theme.rootValue : theme.value;
    return themeValue.backgroundColor;
};
export var getThemeVariant = function (props, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, useRootTheme = _c.useRootTheme;
    var theme = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.uiCore;
    if (!theme) {
        return DEFAULT_THEME.light;
    }
    var themeValue = useRootTheme ? theme.rootValue : theme.value;
    return themeValue.isDark ? themeValue.dark : themeValue.light;
};
var fontGetter = function () { return function (props) {
    return getThemeVariant(props).typography.font;
}; };
var shadowGetter = function (depth, config) {
    if (depth === void 0) { depth = 'regular'; }
    if (config === void 0) { config = {}; }
    return function (props) {
        var _a = config.hover, hover = _a === void 0 ? false : _a, _b = config.dynamic, dynamic = _b === void 0 ? false : _b;
        var getShadowDepth = function () {
            if (dynamic && !isNil(props.depth)) {
                return props.depth;
            }
            return depth;
        };
        var shadowObject = getThemeVariant(props).shadows[getShadowDepth()];
        var buildShadow = function (_a) {
            var x = _a.x, y = _a.y, blur = _a.blur, opacity = _a.opacity;
            return "".concat(x, "px ").concat(y, "px ").concat(blur, "px rgba(24, 20, 31, ").concat(opacity, ")");
        };
        if (!hover) {
            return "".concat(shadowObject.map(buildShadow).join(', '));
        }
        return "".concat(shadowObject
            .map(function (shadow) {
            return buildShadow(shadow.isImpactedByHover
                ? __assign(__assign({}, shadow), { opacity: shadow.opacity + 0.1 }) : shadow);
        })
            .join(', '));
    };
};
var textColorGetter = function (config) {
    if (config === void 0) { config = {}; }
    return function (props) {
        var theme = getThemeVariant(props, { useRootTheme: config.useRootTheme });
        var color;
        if (config.valuePropName && props[config.valuePropName] != null) {
            color = props[config.valuePropName];
        }
        else {
            var variation = void 0;
            if (config.variationPropName && props[config.variationPropName] != null) {
                variation = props[config.variationPropName];
            }
            else if (config.variation) {
                variation = config.variation;
            }
            else {
                variation = 'text';
            }
            color = theme.typography.colors[variation];
        }
        return stringifyColor(color);
    };
};
var colorGetter = function (colorFamily, config) {
    if (config === void 0) { config = {}; }
    return function (props) {
        var _a, _b, _c;
        var theme = getThemeVariant(props, { useRootTheme: config.useRootTheme });
        var color;
        if (config.valuePropName && props[config.valuePropName] != null) {
            color = props[config.valuePropName];
        }
        else if (colorFamily === 'background') {
            color = getCurrentBackground(props, { useRootTheme: config.useRootTheme });
        }
        else {
            var realColorFamily = void 0;
            if (!config.dynamic) {
                realColorFamily = colorFamily;
            }
            else if (props.error) {
                realColorFamily = 'error';
            }
            else if (props.warning) {
                realColorFamily = 'warning';
            }
            else if (props.success) {
                realColorFamily = 'success';
            }
            else if (props.primary) {
                realColorFamily = 'primary';
            }
            else if (props.secondary) {
                realColorFamily = 'secondary';
            }
            else {
                realColorFamily = colorFamily;
            }
            color = theme.colors[realColorFamily][(_a = config.variation) !== null && _a !== void 0 ? _a : 'base'];
        }
        var opacity = (_c = (_b = props.opacity) !== null && _b !== void 0 ? _b : config.opacity) !== null && _c !== void 0 ? _c : 1;
        if (opacity !== 1) {
            color = applyOpacityToColor(color, opacity);
        }
        return stringifyColor(color);
    };
};
var neutralColorGetter = function (strength, config) {
    if (config === void 0) { config = {}; }
    return function (props) {
        var _a, _b;
        var _c = config.gradient, gradient = _c === void 0 ? 'withOpacityFading' : _c;
        var color = getThemeVariant(props).neutralColor[gradient][strength];
        var opacity = (_b = (_a = props.opacity) !== null && _a !== void 0 ? _a : config.opacity) !== null && _b !== void 0 ? _b : 1;
        if (opacity !== 1) {
            color = applyOpacityToColor(color, opacity);
        }
        return stringifyColor(color);
    };
};
export var theme = {
    color: colorGetter,
    textColor: textColorGetter,
    neutralColor: neutralColorGetter,
    font: fontGetter,
    shadow: shadowGetter,
};
//# sourceMappingURL=theme.js.map